import { ScrollBoundaryTools } from './boundary';

export class ScrollUtils {
  public static boundary = ScrollBoundaryTools;
}
